var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-ai-training-design" },
    [
      !_vm.id
        ? _c("main-list", { on: { goDetail: _vm.goDetail } })
        : _c("main-detail", {
            attrs: { id: _vm.id },
            on: { goback: _vm.goback },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }